// static/table_engine_src/util/number.js

export const num = (x, fallback = NaN) => {
  const n = Number(x);
  return Number.isFinite(n) ? n : fallback;
};

export const stripZeros = (s) =>
  String(s)
    .replace(/(\.\d*?)0+$/, "$1")
    .replace(/\.$/, "");

export function clampInt(x, lo, hi) {
  const n = Number(x);
  if (!Number.isFinite(n)) return lo;
  return Math.max(lo, Math.min(hi, Math.trunc(n)));
}